// --- ALLERGY ENUMS ---

export const AllergyCategoryEnum = {
    UNSPECIFIED: 0,
    FOOD: 1,
    MEDICATION: 2,
    ENVIRONMENT: 3,
    BIOLOGIC: 4,
    OTHER: 5,
} as const;

export type AllergyCategoryEnum = typeof AllergyCategoryEnum[keyof typeof AllergyCategoryEnum];

export const AllergySeverityEnum = {
    UNSPECIFIED: 0,
    MILD: 1,
    MODERATE: 2,
    SEVERE: 3,
} as const;

export type AllergySeverityEnum = typeof AllergySeverityEnum[keyof typeof AllergySeverityEnum];

export const AllergyCriticalityEnum = {
    UNSPECIFIED: 0,
    LOW: 1,
    HIGH: 2,
    UNABLE_TO_ASSESS: 3,

} as const;
export type AllergyCriticalityEnum = typeof AllergyCriticalityEnum[keyof typeof AllergyCriticalityEnum];

export const AllergyStatusEnum = {
    ACTIVE: 1,
    INACTIVE: 2,
    RESOLVED: 3,
    REFUTED: 4,
} as const;
export type AllergyStatusEnum = typeof AllergyStatusEnum[keyof typeof AllergyStatusEnum];
